import {
  RenewalCredentials,
  RenewalDetails
} from '../components/common/CommonTypes';
import { ApiHelper } from './apiHelper';

export class RenewalsApi {
  getRenewalDetails(
    credentials: RenewalCredentials,
    token: string,
    successCallback: (data: RenewalDetails) => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): void {
    const url = '/api/renewals/getrenewaldetails';

    new ApiHelper().postDataSecureAsync(
      url,
      credentials,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }

  getRenewalDetailsFromRecordId(
    recordId: string,
    vrn: string,
    renewalSourceSystem: string,
    expAuthId: string,
    campaignId: string,
    token: string,
    successCallback: (data: RenewalDetails) => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): void {
    const url = `/api/renewals/getrenewaldetailsfromrecordid?recordId=${recordId}&source=${renewalSourceSystem}&vrn=${vrn}&expAuthId=${expAuthId}&campaignid=${campaignId}`;

    new ApiHelper().getDataSecureAsync(
      url,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }
}
